var map = {
	"./kid-0.png": [
		2473,
		473
	],
	"./kid-1.png": [
		5568,
		568
	],
	"./kid-2.png": [
		5419,
		419
	],
	"./kid-3.png": [
		4290,
		290
	],
	"./kid-4.png": [
		637,
		637
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2331;
module.exports = webpackAsyncContext;